import React, {useEffect, useRef, useState } from 'react';
import { APIEndpoint, DFPAPIEndpointGalley } from "../../../utils/axios";
import { DataGrid, EditModal, LoaderPop, UploadButton, UploadModal} from "../../../common";
import moment from 'moment';
import CustomSelect from "../../../common/CustomSelect";
import { onDownloadXlsFile,formatDateByTimezone } from '../../../utils/commonFunctions';
import { useTranslation } from 'react-i18next';
import Edit2 from "../../../assets/edit2.svg";
import SettingsIcon from "../../../assets/settings.svg";
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import LoadingGIF from '../../../assets/loadingIn.gif';
import usePermissions from '../../../utils/userPermissions';
const valueGetter = (params) => {
  const { colDef, data } = params;
  if (!data) {
    return '';
  }
  switch (colDef.field) {
    case 'origin':
      return `${data.originName} (${data.origin})`;
    case 'destination':
      return `${data.destinationName} (${data.destination})`;
    default:
      return '';
  }
}

 




const AddFormField = [
  { label: 'Flight Number', attribute: 'flightNumber', type: 'text', required: true, },
  { label: 'Origin', attribute: 'origin', type: 'selectSearch2', required: true, options: 'airports' },
  { label: 'Destination', attribute: 'destination', type: 'selectSearch2', required: true, options: 'airports' },
  { label: 'Base Station', attribute: 'clusterId', type: 'selectSearch2', required: true, options: 'clusters' },
]

const EditFormField = [
  { label: 'Name', attribute: 'storeName', type: 'text', required: true, disabled: true },
  { label: 'Code', attribute: 'storeCode', type: 'text', required: true, disabled: true },
  { label: 'Base Station', attribute: 'clusterId', type: 'selectSearch2', required: true, options: 'clusters' },
  { label: 'International', attribute: 'international', type: 'checkbox', disabled: true, className: 'disabled-checkbox' },
]

const DetailsFormField = [
  { label: 'Tax Id', attribute: 'gstin', type: 'text'},
  { label: 'Tax Type', attribute: 'gstType', type: 'radio-split',required:true,disabled:false },
  { label: 'Max Card Amount', attribute: 'maxAmount', type: 'text',  },
]

export const SectorsPage = (props) => {
  const aircraftOptions = useRef(null);
  const clusterOptions = useRef(null);
  const Fields = useRef([]);
  const { t ,ready} = useTranslation();
  const [state, setState] = useState({ isListReady: false, filterBase: '',filterBaseValue:[], resetDataSource: false, showUploadSector: false,showUploadPriceList:false });

  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({marginBottom:'auto'})
  const aircraftTypeOptions = useRef(null);
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [isDownloading, setIsDownloading] = useState(false);
  const [biDirectional,setBidirectional] = useState(false);
  const [ uploadedFile, setUploadedFile ] = useState([])
  const [ priceSector, setPriceSector ] = useState("");
  const [dateChangeSector,setDateChangeSector]=useState({effectiveDate:new Date()});
  const [dimension,setDimension]=useState(null);
  const [ uploadFileStatusBlock, setUploadFileStatusBlock ] = useState('');

  const { hasPermission: editSectors } = usePermissions('edit', "orn:Cluster:CreateStore");
  const { hasPermission: createSectors } = usePermissions('create', "orn:Cluster:CreateStore");
  const { hasPermission: uploadSectors } = usePermissions('upload', "orn:Cluster:CreateStore");
  const { hasPermission: downloadSectors } = usePermissions('download', "orn:Cluster:CreateStore");

const Columns = [
  { field: 'flightNumber', headerName: 'Flight Number',resizable:true, maxWidth:260, minWidth: 145,flex:1, suppressSizeToFit:true },
  { field: 'origin', headerName: 'Origin',resizable:true,  valueGetter: valueGetter,maxWidth:260, minWidth: 150, flex:1, suppressSizeToFit:true },
  { field: 'destination', headerName: 'Destination',resizable:true,  valueGetter: valueGetter, minWidth: 150,maxWidth:260, flex:1, suppressSizeToFit:true },
  { field: 'clusterName', headerName: 'Base Station',resizable:true,  minWidth: 120,flex:1, suppressSizeToFit:true },
  {headerName:'Seat Pricelist',
      minWidth:150,
      pinned:'right',
       width:170,
       flex:1,
       resizable:false,
       suppressSizeToFit:true,
       cellRenderer: PriceListComponent,
       valueGetter: function(params) {
         return params;
       }
     },

];
 function PriceListComponent(props) {

 const handleUploadClick = async (view = false) => {
  const data = props?.data || {};

  if (view) {
    const { flightNumber, origin, destination } = data;
      const formattedDate = formatDateByTimezone(new Date(), false);
      const effDate = moment(formattedDate).format('YYYY-MM-DD');
    const body = {
      date:effDate,
      filters: { flightNumber, origin, destination }
    };

    try {
      const res = await APIEndpoint.post('seatPricelists/active', body);
      if (res) {
        setState(prev => ({
          ...prev,
          selected: {
            ...data,
            data: res,
            action: 'viewPriceList'
          }
        }));
      }
    } catch (error) {
      console.error('Error fetching price list:', error);
    }

  } else {
    setState(prev => ({
      ...prev,
      selected: { ...data },
      showUploadPriceList: true
    }));
  }
};

  return props.data ? (
    <div>
       <button className="grid-download-btnStyle1" onClick={() => handleUploadClick(true)}>View</button>&nbsp;&nbsp;&nbsp;
      <button className="grid-download-btnStyle1" onClick={()=>handleUploadClick()}>
        Upload
      </button>
    </div>
  ) : null;
}
    useEffect(() => {
     fetchDefinedList();
     // eslint-disable-next-line react-hooks/exhaustive-deps
     },[]);
     useEffect(() => {
      if(state.filterBase){
              const fetchBase=async()=>{
        try {
           const res= await fetchSectors();
          if(res){
            setState((currentState) => {
              return { ...currentState,resetDataSource: true };
            });
          }

        } catch (error) {

        }

      }
      fetchBase();
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
      },[state.filterBase]);

      useEffect(() => {
        if(isDropDownOpen){
          setModalContHeight({marginBottom:'25vh'})
        }else{
          setModalContHeight({marginBottom:'auto'})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDropDownOpen]);
  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
    searchParam: ''
  };

  const fetchSectors = async (iPageNo = 1, iPageLimit = 50, iSearchText = '') => {
    filterData.page = iPageNo;
    filterData.limit = iPageLimit;
    filterData.searchParam = iSearchText;
    if (state.filterBase) {
      filterData.filters = [{ cluster: Number(state.filterBase) }]
    }
    try {
    const res = await APIEndpoint.post('routes/process', filterData);
    return res;
    } catch (error) {

    }


  }


  const fetchDefinedList = async () => {
  try{
    const clusters = await APIEndpoint.get('clusters');
    const airports = await APIEndpoint.get('airports');
    const aircraftType = await DFPAPIEndpointGalley.get('galley/aircraftTypes');

    if (airports.items.length) {
      aircraftOptions.current = airports.items.map((_a,index) => {
        return { key:index,value: _a.locationCode, label: `${_a.locationCode} (${_a.locationName})` }
      })
    }
    if (clusters.result.length) {
      clusterOptions.current = clusters.result.map((_c,index) => {
        return {key:index, value: _c.id, label: _c.value }
      })
    }
    if (aircraftType.result.length) {
      aircraftTypeOptions.current = aircraftType.result.map((_c,index) => {
        return {key:index, value: _c.id, label: _c.value }
      })
    }
    Fields.current = getFormFields()
    setState((_) => {
      return { ..._, isListReady: true,resetDataSource:false }
    })


   }catch (error) {
    console.log("fetchDefinedList error",error)
    return null;
  }
 };
  const handleModalClose = () => {
    setState((currentState) => {
      return { ...currentState, showAddForm: false, showUploadSector: false,showUploadPriceList:false, editRow: null, detailsRow: null, deleteRows: null };
    });
    setModalFormStatusObj({ text: '' });
  }
  const handleAddSector = () => {
    setState((_) => {
      return { ..._, showAddForm:createSectors? true:false }
    })
  }
  const getFormFields = (aircraftType) => {
    return AddFormField.map((_) => {
      let options = [];
      switch (_.attribute) {
        case 'clusterId':
          options = [...(clusterOptions.current || [])]
          options.unshift({ label: t('pages.pagesContent.sectors.baseStationSelectPlaceholder'), value: '' })
          break;
        case 'origin':
          options = [...(aircraftOptions.current || [])]
          options.unshift({ label: t('pages.pagesContent.sectors.originSelectPlaceholder'), value: '' })
          break;
        case 'destination':
          options = [...(aircraftOptions.current || [])]
          options.unshift({ label: t('pages.pagesContent.sectors.destinationSelectPlaceholder'), value: '' })
          break;
          case 'aircraftTypeId':
            options = [...(aircraftTypeOptions.current || [])]
            options.unshift({ label: t('pages.pagesContent.sectors.aircraftTypeSelectPlaceholder'), value: '' })
            break;
          default:
            console.warn(`Unhandled attribute: `,_.attribute);
            break;
      }
      return { ..._, options: options }
    })
  }
  const handleAddSectorSubmit = async (e, values) => {
    let isValid = true;
    if (values != null) {
      isValid = Fields.current.every(((field) => {
        if (field.required && !values[field.attribute]) {
          setModalFormStatusObj({ error:"Please fill out all required fields" });
          return false;
        } else if ((values.origin === values.destination)) {
          setModalFormStatusObj({ error:"Origin and Destination cannot be same" });
          return false;
        }
        return true
      }));
      if (isValid) {
        values.aircraftType = values.aircraftTypes;
        values.clusterName = Number(values.clusterName);
        try {
          const res = await APIEndpoint.post('route/new', values);
          if (res && res.success) {
            setModalFormStatusObj({ text: res.message });
            const timeId = setTimeout(() => {
              setModalFormStatusObj({ text: '' });
              setState(prevState => ({
                ...prevState,
                resetDataSource: true,
                showAddForm: false,
                editRow: false
              }));
            }, 1600)
            return () => clearTimeout(timeId);
          } else {
            setModalFormStatusObj({ error: res.message });
          }
        } catch (error) {
            const errObj = JSON.parse(error?.message);
          setModalFormStatusObj({error:errObj?.data?.message})
        }
      }
    }else{
      setModalFormStatusObj({error:'Please fill all required fields!'})
    }
    
  }
  const handleSelectBaseStation = (e) => {
    setState((_) => {
      return { ..._,filterBase:e?[e][0].value:null,filterBaseValue:[e],resetDataSource: false, showAddForm: false, editRow: null }
    });
  }
  const handleRowAction = async (e, action, row) => {
    let editRow = null, detailsRow = null;
    if (action.value === 'edit' && editSectors) {
      const store = await APIEndpoint.get('store/' + row.storeId);
      if (store.success) {
        editRow = store.result;
        if (!editRow) {
          editRow = { storeCode: '', storeName: '', international: false, clusterId: '' }
        }
        editRow.storeId = row.storeId
      } else {
        alert('Unable to fetch Store')
      }
    } else {
      detailsRow = JSON.parse(JSON.stringify(row))
    }
    setState((currentState) => {
      return { ...currentState, editRow: editRow, detailsRow: detailsRow,resetDataSource:false }
    })
  }
  const onDownloadPricelistSampleFile = async() => {
    onDownloadXlsFile('samples/downloads/SeatPricelist_Upload_Sample','seat_pricelist')
   }
     const onPriceListUploadFileChangeHandler = async (e) => {
       const file=e.target.files[0];
       setUploadedFile(e.target.files[0]);
       setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

  const formattedDate = formatDateByTimezone(new Date(dateChangeSector.effectiveDate), false);
const effDate = moment(formattedDate).format('YYYY-MM-DD');

const body = {
  efd: formattedDate,
  ...(dimension === 'sectorWise' && {
    fno: state.selected.flightNumber,
    org: state.selected.origin,
    dest: state.selected.destination
  }),
  ...(dimension !== 'sectorWise' && {
    org: state.selected.origin,
    dest: state.selected.destination,
    bd: biDirectional ? 'yes' : 'no'
  })
};

   const formData = new FormData();
formData.append('scheduleLater', false);
formData.append('effectiveDate', formattedDate);
formData.append('flightNumber', dimension === 'sectorWise' ? state.selected.flightNumber : '');
formData.append('origin', state.selected.origin);
formData.append('destination', state.selected.destination);
if (dimension !== 'sectorWise') {
formData.append('bi-directional', biDirectional ? 'yes' : 'no');
}
formData.append('file', file);

try {
const params = new URLSearchParams({
  efd: effDate,
  org: state.selected.origin,
  dest: state.selected.destination,
  ...(dimension === 'sectorWise' && { fno: state.selected.flightNumber }),
  ...(dimension === 'routeWise' && { bd: biDirectional ? 'yes' : 'no' })
});

const url = `seatPricelists/upload?${params.toString()}`;

await APIEndpoint.post(url, formData, body);
         setUploadedFile([]);
         
         setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
   
       }  catch(error) {
         let { status, data } = JSON.parse( error.message );
         let msgHeading = data?.Error || data?.message || error.message;
         msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;
   
         let msgContent = "";
         if (status === 400 && data?.errors) {
           data.errors.forEach( _ => {
           const lineNum = _.lineNumber;
           const errorMsgArr = [];
           _.errors.forEach(erObj => {
             errorMsgArr.push(`${erObj.field ? erObj.field : ""} | ${erObj.message} \n<br>`);
   
           });
   
           msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
       });
     } else if(status===0 && !data){
       msgContent += `Error occurred while uploading seat pricelist sheet!<br>Please try again.`;
   }
   else if(status === 400 && data && data?.Error){
     msgHeading = data?.Error;
     msgContent += `Error occurred while uploading seat pricelist sheet!<br>Please try again.`;
   }
     else {
       msgContent += `Error occurred while uploading seat pricelist sheet!<br>Please fix the errors and re-upload.`;
     }
   
   
         setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                   "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                                 );
       }
   
   };

  const handleEditSectorSubmit = async (e, values) => {
    setModalFormStatusObj({ text: '' });
    if (values != null) {
      if (values.clusterId !== '') {
        values = {
          ...state.editRow,
          ...values,
          clusterName: Number(values.clusterName),
          activePayments: []
        }
        try {
          const res = await APIEndpoint.post('route/update/' + state.editRow.storeId,  values  );
          if (res && res.success) {
            setModalFormStatusObj({ text: res.msg });
          }
        } catch (error) {
           const errObj = JSON.parse(error?.message);
          setModalFormStatusObj({ error: errObj?.data?.msg||"Something went wrong!" });
        }
      }
    }else{
      try {
         const res = await APIEndpoint.post('route/update/' + state.editRow.storeId,  state.editRow  );
        if (res && res.success) {
          setModalFormStatusObj({ text: res.msg });

        }
      } catch (error) {
        const errObj = JSON.parse(error?.message);
        setModalFormStatusObj({ error: errObj?.data?.msg ||"Something went wrong!"});
      }
    }
    setTimeout(() => {
      setModalFormStatusObj({ text:'' });
      setState((currentState) => {
        return { ...currentState, editRow: null,resetDataSource:true }
      })
      // handleSelectBaseStation({ target: { value: state.filterBase } });
    }, 1600);
  }



  const handleSaveStore = async (e, values) => {

      const data=
        {
          storeId: state?.detailsRow?.storeId,
          indentEnabled: false,
          dailyStockReset: false,
          enableSubcategories: false,
          inventoryType: "servings",
          maxCardAmount:values?.maxAmount?Number(values.maxAmount):null,
          gstType:values?.inclusiveGst?'inclusive':values?.exclusiveGst?'exclusive':null,
          gstIn:values?.gstin||null
      }

    const modData=Object.fromEntries(Object.entries(data).filter(([key,value])=>(value!==null&&value!=="")))

        try {
          const res = await APIEndpoint.post('store/services', modData);
          if (res.success) {
            setModalFormStatusObj({text:'Successfully saved store settings'})
            const timeId = setTimeout(() => {
              setModalFormStatusObj({ text: '' });
              setState(prevState => ({
                ...prevState,
                resetDataSource: true,
                showAddForm: false,
                detailsRow:false,
                editRow: false
              }));
            }, 1600);

            return () => clearTimeout(timeId);
          }

        } catch (error) {
        const errObj = JSON.parse(error?.message);
          setModalFormStatusObj({error:errObj?.data?.msg||'Something went wrong. Please try again after some time.'})

        }


  }


  const onUploadClose = () => {
    setUploadedFile([]);
    setUploadFileStatusBlock('');
    setPriceSector("");
    setBidirectional(false);
    setDimension(null);
    setState((_) => ({ ..._, showUploadSector: false ,showUploadPriceList:false}))
  }
  const fetchEditSector = async (st) => {
    if (!st) return;
  };

  const onUploadFileChangeHandler = async (e) => {
    const file=e.target.files[0];
    setUploadedFile(e.target.files[0]);
    setUploadFileStatusBlock('<p>Please wait while we process your data...</p>');

    const formData = new FormData();
    formData.append('file', file);
    try {
      await APIEndpoint.post(`routes/upload`, formData);
      setUploadedFile([]);
      setUploadFileStatusBlock('<p>File Imported Successfully.</p>');
    } catch (error) {
      e.target.value = null;
      setUploadedFile([]);
      let { status, data } = JSON.parse( error.message );
      let msgHeading = data?.Error || data?.message || error?.message;
      msgHeading= msgHeading.includes('status')?`Failed to upload.`:msgHeading;

      let msgContent = "";
      if (status === 400 && data?.errors) {
            data.errors.forEach( _ => {
            const lineNum = _.lineNumber;
            const errorMsgArr = [];
            _.errors.forEach(erObj => {
              errorMsgArr.push(`${erObj.field ? erObj.field : ''} | ${erObj.message} \n<br>`);
            });

            msgContent += '<br>Line ' + lineNum + ': \n<br>' + errorMsgArr.join(' ');
        });
      } else if(status===0 && !data){
        msgContent += `Error occurred while uploading sector!<br>Please try again.`;
    }
    else if(status === 400 && data && data?.Error){
      msgHeading = data?.Error;
      msgContent += `Error occurred while uploading sector!<br>Please fix the errors and re-upload.`;
    }
      else {
        msgContent += `Error occurred while uploading sector!<br>Please fix the errors and re-upload.`;
      }

      setUploadFileStatusBlock("<p class='listErrorMessagesCls'>"+ msgHeading + "</p>" +
                                "<p class='listErrorMessagesCls sm-scrollbar border p-2 pt-1'>" + msgContent +"</p>"
                              );
    }
};


  const onDownloadSampleFile = async (e) => {
    onDownloadXlsFile('samples/downloads/Routes_Upload_Sample', 'Routes_Upload_Sample')
  }

  const onDownloadSectors=async()=>{
    let header={
      'Accept':'text/csv'
    }
    try {
      setIsDownloading(true)
    const res= await APIEndpoint.post(`downloads/routes`,{reportType: "sectors"},header);
    if(res.status==='scheduled'){
      setTimeout(() => {
        const dowId = APIEndpoint.get(`downloads/status/${res.id}`);
        dowId.then((val)=> {
          if(val.status==="completed"){
            APIEndpoint.get(`downloads/analytics/${val.fileName}${val.fileExtension}`).then((ItemMasterDwnld) => {
              const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', val.fileName+'.csv'); //or any other extension
              document.body.appendChild(link);
              link.click();
              setIsDownloading(false)
          });

          }
        })
        }, 6000);
    }
    }
      catch (error) {
        setIsDownloading(false)
        console.error(error);
      }
  }
      const onClose = () => {
      if (state.selected?.action2 === "IntlPriceList") {
        setState((prev) => ({
          ...prev,
          selected: {
            ...prev.selected,
            action2: false, 
          },
        }));
      } else {
        setState((prev) => ({
          ...prev,
          selected: false,
          edit: false,
        }));
    
        setModalFormStatusObj({ text: '' });
      }
    };
 
     const handleViewIntlPriceClick = (indx) => {
      setState((_prev) => {
        const selectedData = Array.isArray(_prev.selected.data) && _prev.selected.data[0]?.items[indx]
          ? _prev.selected.data[0]?.items[indx]
          : {};
        return {
          ..._prev,
          selected: {
            ..._prev.selected,
            action2: "IntlPriceList"
          },
          data: selectedData
        };
      });
    };

const handleOnChangeAdd=()=>{
  setModalFormStatusObj({text:""});
}
  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        Boolean(state.isListReady) ?
        <>
          <DataGrid
            columnResize
            resetDataSource={state.resetDataSource}
            showDefaultFilters
            className='full-flex'
            columns={Columns}
            pageType={false}
            actionProperties={{pinned:'right'}}
            getRows={fetchSectors}
            noResultsMessage={'No Items Found'}
            addButton={{
              title: t('pages.pagesContent.sectors.addButtonTitle'),
              onClick: handleAddSector,
              className: 'margRight'

            }}
            RightComponent={() => {
              return (
                <>
                <div className="margTop10 flexRow justifyContentFlexEnd alignItemsBaseline">
               {uploadSectors?<UploadButton
               label={t('pages.pagesContent.sectors.uploadBtn')}
               showLabel={false}
               className=""
              onClick={() => setState((_) => ({ ..._, showUploadSector: true }))}
               />:null}

         {downloadSectors? <div className="flexRow justifyContentFlexStart margRight">

                      {isDownloading ? (
                               <button className="margRight">
                                    <img
                                      src={LoadingGIF}
                                      className="margBottom0 icon-size-min"
                                      alt="Loading"
                                    />
                                  </button>
                              ) : (

                                  <button
                                    disabled={isDownloading}
                                    className="margRight"
                                    style={{ cursor: 'pointer' }}
                                    title={"Download Operation Stats"}
                                   onClick={onDownloadSectors}
                                  >
                                    <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                                  </button>
                                )
                              }

          </div>:<></>}


            </div>


                <button className='flexRow justifyContentFlexEnd saleType-div'>

              <CustomSelect
                options={clusterOptions.current}
                placeHolder={t('pages.pagesContent.sectors.clusterSelectPlaceholder')}
                width={'11rem'}
                value={state.filterBaseValue}
                onChange={handleSelectBaseStation}
              />
              </button>&nbsp;&nbsp;
              </>

              )
            }}
          actions={[
              { title:'Actions',minWidth:100,maxWidth:120,detail: [{ src: Edit2, value: "edit",title:'Edit' }, { src: SettingsIcon, value: 'settings',title:'Settings' }] }
            ]}
            onAction={handleRowAction}
          />
          {
            state && fetchEditSector(state) && state.showAddForm &&
            <EditModal
              title={t('pages.pagesContent.sectors.addModalTitle')}
              modalFormStatusObj={modalFormStatusObj}
              customContentHeight={ModalContHeight}
              setIsDropdownOpen={setIsDropdownOpen}
              onChange={handleOnChangeAdd}
              onClose={handleModalClose}
              buttonLabel="Save"
              onSubmit={handleAddSectorSubmit}
              fields={Fields.current}
            />
          }
          {
            state && Boolean(state.editRow) && fetchEditSector(state) &&
            <EditModal
              title={t('pages.pagesContent.sectors.editModalTitle')}
              modalFormStatusObj={modalFormStatusObj}
              customContentHeight={ModalContHeight}
              setIsDropdownOpen={setIsDropdownOpen}
              onClose={handleModalClose}
              buttonLabel="Save"
              onSubmit={handleEditSectorSubmit}
              fields={EditFormField.map((elt) => {
                return {
                  ...elt,
                  initialValue: state.editRow[elt.attribute],
                  options: elt.attribute === 'clusterId' ? Fields.current[3].options : []
                }
              })
              }
            />
          }
        </>
      :<LoaderPop/>}
      
              {state && Boolean(state.selected) && state.selected?.action === "viewPriceList" && (
                    <>
                      <EditModal
                        key={state.selected?.action}
                        title={ `Seat Pricelist -  ${state.selected?.storeCode}`}
                        onClose={onClose}
                        showFieldsInColumn={true}
                        showDone={false}
                      >
                      <div className='dialog__body_container flexRow justifyContentSpaceBetween flexWrap'>
  
                  <div className="flexRow alignItemsCenter"  id="caterer-table" style={{whiteSpace:'nowrap', width:'100%'}}>
                  <table>
                    <thead>
                      <tr style={{width:'100%'}} className='sticky'>
                      <th style={{width:"20%"}}>From</th>
                        <th style={{width:"20%"}}>To</th>
                        <th>CGST</th>
                        <th>SGST</th>
                        <th>UTGST</th>
                        <th>IGST</th>
                        <th>Price</th>
                        <th>Price(SSR)</th>
                        <th>Intl. Pricing</th>
                      </tr>
                    </thead>
                    <tbody>
                    {Array.isArray(state.selected.data) && state.selected.data.length > 0 && state.selected.data[0]?.items?.length > 0 ? (
                    state.selected.data[0]?.items.map((item, idx) => (
                    <tr key={item?._id ?? idx}  className={!Number(idx % 2) ? "tableEvenRowClass" : "tableRowClass"} style={{ color: "#fff" }}>
                    <td>{item?.fromCategory ?? "—"}</td>
                    <td>{item?.toCategory ?? "—"}</td>
                    <td>{item?.cgst ?? "—"}</td>
                    <td>{item?.sgst ?? "—"}</td>
                    <td>{item?.utgst ?? "—"}</td>
                    <td>{item?.igst ?? "—"}</td>
                    <td>{item?.itemPrice ?? "—"}</td>
                    <td>{item?.priceSSR ?? "NA"}</td>
                    <td>
                    <button
                    className="grid-download-btnStyle1"
                    style={{ marginLeft: "1rem" }}
                    onClick={()=>handleViewIntlPriceClick(idx)}
                    >
                    View
                    </button>
                    </td>
                    </tr>
                    ))
                    ) : (
                    <tr>
                    <td colSpan={9} style={{ textAlign: "center" }}>
                    No Items Found
                    </td>
                    </tr>
                    )}
                    </tbody>
      
                  </table>
            
                </div>
                </div>
            
                      </EditModal>
                      </>
                    )
                 }
                 {state && Boolean(state.selected) && state.selected?.action2 === "IntlPriceList"&& (
                  <EditModal
                        key={state.selected?.action2}
                        title={ `Intl Pricing -  ${state.selected?.storeCode}`}
                        onClose={onClose}
                        showDone={false}
                        showFieldsInColumn={true}>
                      <div className="flexRow alignItemsCenter"  id="caterer-table" style={{whiteSpace:'nowrap', width:'100%'}}>
                      <table>
                      <thead>
                      <tr style={{ width: '100%' }} className="sticky">
                      <th>Currency</th>
                      <th>Amount</th>
                      <th>Amount (SSR)</th>
                      </tr>
                      </thead>
                      <tbody>
                      {state?.data && state.data?.intlPrices && state.data?.intlPrices?.length>0 ? (
                      state.data.intlPrices?.map((item, index) => (
                      <tr key={index}   className={!Number(index % 2) ? "tableEvenRowClass" : "tableRowClass"} style={{ color: "#fff" }}>
                      <td>{item?.currencyName && item?.currencyCode ? `${item.currencyName} (${item.currencyCode})` : "NA"}</td>
                      <td>{item?.amount ?? "NA"}</td>
                      {/* Support for legacy API responses: some return 'amountssr', others 'amountSsr'. */}
                      <td>{item?.amountssr ?? item?.amountSsr ?? "NA"}</td>
                      </tr>
                      ))
                      ) : (
                      <tr>
                      <td colSpan={3} style={{ textAlign: "center" }}>
                      No Items Found
                      </td>
                      </tr>
                      )}
                      </tbody>
                      </table>
      
                      </div>
                    </EditModal>
                 )}

{
  state.showUploadSector && (
    <UploadModal
      modelTitle={t('pages.pagesContent.sectors.uploadBtn')}
      onUploadClose={onUploadClose}
      onDownloadSampleFile={onDownloadSampleFile}
      onUploadFileChangeHandler={onUploadFileChangeHandler}
      uploadedFile={uploadedFile}
      uploadFileStatusBlock={uploadFileStatusBlock}
    />
  )
}

{
  state.showUploadPriceList && (
    <UploadModal
      modelTitle={`Upload Seat Pricelist for Sector - ${state.selected?.storeCode || ''}`}
      onUploadClose={onUploadClose}
      onDownloadSampleFile={(onDownloadPricelistSampleFile)}
      uploadedFile={uploadedFile}
      onUploadFileChangeHandler={onPriceListUploadFileChangeHandler}
      uploadFileStatusBlock={uploadFileStatusBlock}
      priceSector={priceSector}
      biDirectional={biDirectional}
      setBidirectional={setBidirectional}
      dimension={dimension}
      setDimension={setDimension}
      setPriceSector={setPriceSector}
      dateChangeSector={dateChangeSector}
      setDateChangeSector={setDateChangeSector}
    />
  )
}
         
      {
       state && Boolean(state.detailsRow) && fetchEditSector(state) &&
        <EditModal
          buttonLabel={t('pages.pagesContent.sectors.btnSaveStoreSettings')}
          title={t('pages.pagesContent.sectors.updateStoreSettings')}
          onClose={handleModalClose}
          onSubmit={handleSaveStore}
          customContentHeight={ModalContHeight}
          setIsDropdownOpen={setIsDropdownOpen}
          modalFormStatusObj={modalFormStatusObj}
          fields={DetailsFormField.map((elt) => {
            return {
              ...elt,
              initialValue: state.detailsRow[elt.attribute]
            }
          })
          }
        />
      }
       {
                !ready &&<div className='overlay_hide sub'></div>
                }
    </div>
  )
}